import { render } from "./InstanceRelInput.vue?vue&type=template&id=77a41805&ts=true"
import script from "./InstanceRelInput.vue?vue&type=script&lang=ts"
export * from "./InstanceRelInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__